<script>
    import {
        Chart as ChartJS,
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend,
        Colors
    } from 'chart.js';
    import { Bar } from 'vue-chartjs';

    import ChartDataLabels from 'chartjs-plugin-datalabels';

    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend,
        Colors,
        ChartDataLabels,
    );

    // Import general mixin for shared functionality.
    import mixin from '../../mixin';

    export default {
        mixins: [mixin],
        components: {
            Bar,
        },
        props: {
            data: Object,
        },
        data() {
            return {
                facetAlias: 'fase_label',
                options: {
                    locale: 'nl-NL',
                    maintainAspectRatio: false,
                    scales: {
                        x: {
                            grid: {
                                display: false
                            },
                        },
                    },
                    plugins: {
                        legend: {
                            display: false,
                        },
                        title: {
                            display: true,
                            text: this.$store.getters.getText('dashboardWidgetPhase')
                        },
                        datalabels: {
                            display: 'auto',
                            align: 'end',
                            anchor: 'start',
                            font: {
                                lineHeight: 1,
                            },
                            padding: {
                                bottom: 0,
                            }
                        }
                    },
                },
            };
        },
        computed: {
            facetsSet() {
                return this.data && this.data.facets && this.data.facets.length;
            },
            dataSets() {
                const defaultValue = { labels: [], datasets: [] };
                if (!this.facetsSet) return defaultValue;
                const facet = this.data.facets.find(f => f.alias === this.facetAlias);
                if (!facet || !facet.options || !facet.options.length) return defaultValue;
                const labels = facet.options.map(o => o.valueAlias);
                const phases = this.sortPhases(labels);
                const data = phases.map(phase => facet.options.find(o => o.valueAlias === phase.label).filteredAmount);
                const backgroundColor = this.$store.getters.getHighContrast ? '#833de6' : '#53b7d8';

                return {
                    labels: phases.map(phase => phase.label),
                    datasets: [{
                        data: data,
                        backgroundColor: backgroundColor,
                    }],
                };
            },
            computedOptions() {
                return {
                    ...this.options,
                    plugins: {
                        ...this.options.plugins,
                        datalabels: {
                            ...this.options.plugins.datalabels,
                            color: this.$store.getters.getHighContrast ? '#ffffff' : '#000000',
                        },
                    },
                };
            },
        },
    };
</script>

<template>
    <div class="dashboard-widget">
        <Bar :data="dataSets" :options="computedOptions" />
    </div>
</template>
